module.exports = __webpack_public_path__ + "img/暂无内容@2x.35ae495f.png";